import type { FieldComponents } from '@/shared/components/form-fields/types';
import { FIELD_MAX_LENGTHS } from '@/shared/constants';
import { withForm } from '../../hooks/use-proposal-decision-form.hook';
import { DecisionAttachmentsField } from './decision-attachments-field.component';
import {
  decisionFormOpts,
  REJECTION_REASON_OPTIONS,
} from './decision-form-options';

export const DecisionRejectFields = withForm({
  ...decisionFormOpts,
  props: {},
  render: ({ form }) => (
    <>
      <form.AppField
        name='rejectionReason'
        validators={{
          onChange: ({ value }: { value: string | undefined }) => {
            if (!value?.trim()) return 'O motivo de recusa é obrigatório';
            return undefined;
          },
          onSubmit: ({ value }: { value: string | undefined }) => {
            if (!value?.trim()) return 'O motivo de recusa é obrigatório';
            return undefined;
          },
        }}
        children={(field: FieldComponents) => (
          <field.SelectField
            label='Motivo de Recusa'
            placeholder='Selecione o motivo de recusa'
            required
            options={REJECTION_REASON_OPTIONS}
          />
        )}
      />

      <form.AppField
        name='rejectionObs'
        children={(field: FieldComponents) => (
          <field.TextareaField
            label='Observações sobre o motivo de Recusa'
            placeholder='Digite as observações sobre o motivo de recusa que será enviado para o segurado, corretor e executivo comercial'
            helperMessage='Descreva o motivo da recusa que será utilizado na carta de recusa'
            rows={5}
            maxLength={FIELD_MAX_LENGTHS.textarea}
          />
        )}
      />

      <DecisionAttachmentsField form={form} />
    </>
  ),
});
